export interface KagiPriceFieldOption {
  title: string;
  sharpCharts2Id: string;
};

export const KAGI_PRICE_FIELD_OPTION_HIGH_LOW: KagiPriceFieldOption = {
  title: 'High/Low',
  sharpCharts2Id: 'hilo'
};

export const KAGI_PRICE_FIELD_OPTION_CLOSE: KagiPriceFieldOption = {
  title: 'Close',
  sharpCharts2Id: 'close'
};

export const DEFAULT_KAGI_PRICE_FIELD_OPTION: KagiPriceFieldOption = KAGI_PRICE_FIELD_OPTION_HIGH_LOW;

export const KAGI_PRICE_FIELD_OPTIONS_ARRAY: KagiPriceFieldOption[] = [
  KAGI_PRICE_FIELD_OPTION_HIGH_LOW,
  KAGI_PRICE_FIELD_OPTION_CLOSE
];
